import { render, staticRenderFns } from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=template&id=680df290&scoped=true"
import script from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=script&lang=js"
export * from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=script&lang=js"
import style0 from "./AIChatWidgetPdpTemplateLightbox.vue?vue&type=style&index=0&id=680df290&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680df290",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680df290')) {
      api.createRecord('680df290', component.options)
    } else {
      api.reload('680df290', component.options)
    }
    module.hot.accept("./AIChatWidgetPdpTemplateLightbox.vue?vue&type=template&id=680df290&scoped=true", function () {
      api.rerender('680df290', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/widgets/AIChatWidgetPdpTemplateLightbox.vue"
export default component.exports